import React from 'react';
import OtherPages from '../../Components/OtherPages/OtherPages';
import './ErrorPage.scss'
import Button from '../../Components/Button/Button';

function ErrorPage() {
    return (
        <div>
            <OtherPages
                pageName="Error 404"
            />

            <div className="Error404Container">
                <div className="container">
                    <div className="pagesubTitle">Error 404</div>
                    <h2 className="pageTitle">This is Error <span>404 Page</span></h2>

                    <div className="errorBtn">
                        <Button
                            text="Go To Home"
                           buttonLink="/"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ErrorPage